'use client'

import { Body, Button, Caption, H5 } from '@material-bank/mb3-components'
import {
  Form,
  Input,
  z,
  createFormSchema,
  SubmitHandler,
} from '@material-bank/mtag-forms'
import { useTranslations } from '@material-bank/i18n'
import { MbLogoLink } from '../MbLogoLink/MbLogoLink'

function getEmailStepSchema(emailValidationMessage: string) {
  return z.object({
    email: z.string().email(emailValidationMessage),
  })
}

type EmailStepData = z.infer<ReturnType<typeof getEmailStepSchema>>

type EmailStepProps = {
  isLoading: boolean
  error: string | null
  onSubmit: (email: string) => void
}

export function EmailStep({ isLoading, error, onSubmit }: EmailStepProps) {
  const t = useTranslations('authentication.emailStep')
  const emailStepSchema = getEmailStepSchema(t('emailValidation'))

  const submitHandler: SubmitHandler<EmailStepData> = (data) => {
    onSubmit(data.email)
  }

  return (
    <div className="flex flex-col gap-[48px]">
      <MbLogoLink />

      <div className="flex flex-col gap-8">
        <div className="flex flex-col gap-2">
          <H5 weight="semibold">{t('heading')}</H5>
          <Body className="text-muted-foreground" weight="regular">
            {t('subheading')}
          </Body>
        </div>

        <Form
          formProps={createFormSchema(emailStepSchema)}
          onSubmit={submitHandler}
          className="flex flex-col gap-4"
        >
          <Input
            name="email"
            label={t('emailLabel')}
            type="email"
            placeholder={t('emailPlaceholder')}
            disabled={isLoading}
            autoFocus
            autoComplete="email"
          />
          {error ? (
            <Body variant="small" className="text-red-600">
              {error}
            </Body>
          ) : null}

          <Button
            type="submit"
            variant="default"
            size="lg"
            disabled={isLoading}
            className="w-full"
          >
            {isLoading ? t('submitButtonLoading') : t('submitButton')}
          </Button>
          <Caption className="text-gray-500 text-center">
            {t('termsAgreement')}
          </Caption>
        </Form>
      </div>
    </div>
  )
}
